import { Col, Row, Container } from "reactstrap";
import { useTranslation } from 'react-i18next';
import {
  PricingTable,
  TableHeader,
  TableRow,
  TableCell,
} from "./Sponsors.stylesheets.js";

export const SponsorsContent = () => {
  const { t } = useTranslation();

  return (
    <div style={{
      paddingTop: '60px',
      paddingBottom: '60px',
      backgroundColor: '#f8f9fa'
    }}>
      <Container>
        {/* Título principal */}
        <Row className="mb-5">
          <Col>
            <h1 className="text-center" style={{ 
              color: '#333333',
              fontWeight: 'bold',
              marginBottom: '1rem'
            }}>
              {t('PATROCINADORES')}
            </h1>
            <p className="text-center lead" style={{ 
              color: '#333333'
            }}>
              {t('¡Únete a nosotros como patrocinador del CEC 2026 y conecta con el ecosistema espacial de la región!')}
            </p>
          </Col>
        </Row>

        {/* Sección de oportunidades de patrocinio */}
        <Row className="mb-3">
          <Col>
            <h2 className="text-center mb-3" style={{ color: '#333333', fontWeight: '600' }}>
              {t('Oportunidades de Patrocinio')}
            </h2>
            <p className="text-center mb-4" style={{ color: '#555', fontSize: '1.1rem' }}>
              {t('Elige a continuación el nivel que mejor se adapte a tu organización')}
            </p>
          </Col>
        </Row>

        {/* Tabla de comparación de beneficios */}
        <Row className="mb-5">
          <Col>
            <div style={{ overflowX: 'auto' }}>
              <PricingTable>
                <thead>
                  <TableHeader>
                    <th style={{ textAlign: 'center' }}>{t('Beneficios')}</th>
                    <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                      {t('Planeta')} 🪐<br/>
                      <small style={{ color: '#ffffff', opacity: '0.9', fontWeight: 'bold' }}>US$500</small>
                    </th>
                    <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                      {t('Estrella')} ⭐<br/>
                      <small style={{ color: '#ffffff', opacity: '0.9', fontWeight: 'bold' }}>US$1,000</small>
                    </th>
                    <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                      {t('Sistema Solar')} ☀️<br/>
                      <small style={{ color: '#ffffff', opacity: '0.9', fontWeight: 'bold' }}>US$2,500</small>
                    </th>
                    <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                      {t('Galaxia')} 🌌<br/>
                      <small style={{ color: '#ffffff', opacity: '0.9', fontWeight: 'bold' }}>US$5,000</small>
                    </th>
                    <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                      {t('Constelación')} ✨<br/>
                      <small style={{ color: '#ffffff', opacity: '0.9', fontWeight: 'bold' }}>US$10,000</small>
                    </th>
                  </TableHeader>
                </thead>
                <tbody>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Logo en el sitio web y documentos del CEC 2026')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Stand en el área de exhibiciones')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Artículos de marca en el paquete de delegados')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Reconocimiento en ceremonias de apertura y clausura del congreso')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Descripción de tu organización en la guía del evento')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{t('1/2 página')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{t('1 página')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{t('2 páginas')}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Registros al congreso incluidos')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>1</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>2</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>3</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>5</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>8</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Personas como participantes en paneles')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>1</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>2</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Oradores principales (Keynote speakers)')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>1</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ textAlign: 'center', fontWeight: '500' }}>{t('Presentación en la ceremonia de clausura')}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>-</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>✓</TableCell>
                  </TableRow>
                </tbody>
              </PricingTable>
            </div>
          </Col>
        </Row>

        {/* Patrocinios personalizados */}
        <Row className="mb-5">
          <Col lg="6" className="mb-4">
            <div className="custom-sponsorship-card p-4" style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '15px',
              color: 'white',
              height: '100%',
              minHeight: '250px',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <h3 className="mb-3">{t('Patrocinio Personalizado')} ☕</h3>
              <h4 className="mb-3">{t('Patrocinador de Coffee Breaks')}</h4>
              <p style={{ textAlign: 'justify', flex: '1' }}>{t('Sé el patrocinador exclusivo de los coffee breaks durante todo el evento. Tu marca estará presente en cada momento de networking e intercambio entre participantes.')}</p>
              <a 
                href="https://cecspace.org/contact" 
                className="btn btn-light mt-auto" 
                style={{ 
                  alignSelf: 'flex-start',
                  padding: '10px 30px',
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                }}
              >
                {t('Solicitar información')}
              </a>
            </div>
          </Col>
          <Col lg="6" className="mb-4">
            <div className="custom-sponsorship-card p-4" style={{
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              borderRadius: '15px',
              color: 'white',
              height: '100%',
              minHeight: '250px',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <h3 className="mb-3">{t('Patrocinio Personalizado')} 🎉</h3>
              <h4 className="mb-3">{t('Patrocinador de la Ceremonia de Apertura')}</h4>
              <p style={{ textAlign: 'justify', flex: '1' }}>{t('Patrocina la ceremonia de apertura y da la bienvenida a todos los participantes del congreso con tu marca en el centro del escenario.')}</p>
              <a 
                href="https://cecspace.org/contact" 
                className="btn btn-light mt-auto" 
                style={{ 
                  alignSelf: 'flex-start',
                  padding: '10px 30px',
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                }}
              >
                {t('Solicitar información')}
              </a>
            </div>
          </Col>
        </Row>

        {/* Estadísticas del CEC */}
        <Row className="mb-5 py-5" style={{ background: '#f8f9fa', borderRadius: '15px' }}>
          <Col>
            <h2 className="text-center mb-3" style={{ color: '#333333', fontWeight: '600' }}>
              {t('¿Por qué patrocinar el CEC 2026?')}
            </h2>
            <p className="text-center mb-5" style={{ color: '#555', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto 3rem auto' }}>
              {t('El Congreso Espacial Centroamericano se ha consolidado como el evento más importante del sector aeroespacial en la región, conectando a profesionales, académicos y entusiastas del espacio de todo el mundo. Estos son los resultados del CEC 2024:')}
            </p>
            <Row>
              <Col md="3" className="text-center mb-4">
                <div>
                  <h3 className="stats-number" style={{ fontSize: '3.5rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>+400</h3>
                  <p className="stats-text" style={{ fontWeight: '600', fontSize: '1.1rem' }}>{t('Participantes')}</p>
                </div>
              </Col>
              <Col md="3" className="text-center mb-4">
                <div>
                  <h3 className="stats-number" style={{ fontSize: '3.5rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>24</h3>
                  <p className="stats-text" style={{ fontWeight: '600', fontSize: '1.1rem' }}>{t('Países')}</p>
                </div>  
              </Col>
              <Col md="3" className="text-center mb-4">
                <div>
                  <h3 className="stats-number" style={{ fontSize: '3.5rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>9</h3>
                  <p className="stats-text" style={{ fontWeight: '600', fontSize: '1.1rem' }}>{t('Agencias Espaciales Presentes')}</p>
                </div>
              </Col>
              <Col md="3" className="text-center mb-4">
                <div>
                  <h3 className="stats-number" style={{ fontSize: '3.5rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>45%</h3>
                  <p className="stats-text" style={{ fontWeight: '600', fontSize: '1.1rem' }}>{t('Participación Femenina')}</p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* CTA Final */}
        <Row className="mt-5">
          <Col>
            <div className="text-center p-5 cta-section" style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '15px',
              color: 'white',
              boxShadow: '0 15px 35px rgba(0,0,0,0.15)'
            }}>
              <h3 className="mb-3" style={{ fontWeight: 'bold' }}>
                {t('¿Listo para apoyar al CEC 2026?')} 🚀
              </h3>
              <p className="lead mb-4">
                {t('¡Conecta con la comunidad espacial más importante de Centroamérica y Latinoamérica!')}
              </p>
              <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                <a
                  href="https://cecspace.org/contact"
                  className="btn btn-outline-light btn-lg"
                  style={{
                    fontWeight: '600',
                    color: '#764ba2',
                    letterSpacing: '0.5px',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                  }}
                >
                  {t('CONTACTAR AL COMITÉ')}
                </a>
                <a
                  href="/assets/documents/sponsorship-package-cec2026-es.pdf"
                  className="btn btn-outline-light btn-lg"
                  style={{
                    fontWeight: '600',
                    borderWidth: '2px'
                  }}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('DESCARGAR PAQUETE DE PATROCINIO (ES)')}
                </a>
                <a
                  href="/assets/documents/sponsorship-package-cec2026-en.pdf"
                  className="btn btn-outline-light btn-lg"
                  style={{
                    fontWeight: '600',
                    borderWidth: '2px'
                  }}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('DESCARGAR PAQUETE DE PATROCINIO (EN)')}
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      
      {/* Estilos locales */}
      <style jsx="true">{`
        .stats-number {
          color: #000000 !important;
          text-shadow: none !important;
          filter: none !important;
        }
        .stats-text {
          color: #000000 !important;
          text-shadow: none !important;
          filter: none !important;
        }
      `}</style>
    </div>
  );
}